import React, { useState, useEffect } from 'react';
import { X, Clock } from 'lucide-react';
import './NotesModal.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const NotesModal = ({ isOpen, notes, onClose, title = 'Full Notes', phone = null, leadStatus = null, view = 'notes' }) => {
  const [history, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const isHistoryView = view === 'history';

  // Fetch full history when modal is opened in history mode
  useEffect(() => {
    if (isOpen && isHistoryView && phone) {
      setLoadingHistory(true);
      const token = localStorage.getItem('token');
      fetch(`${API_BASE}/agent-statuses?phones=${encodeURIComponent(phone)}&history=true`, {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        }
      })
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.data)) {
          setHistory(data.data);
        } else {
          setHistory([]);
        }
      })
      .catch(err => console.error('Failed to fetch history:', err))
      .finally(() => setLoadingHistory(false));
    }
  }, [isOpen, isHistoryView, phone]);

  useEffect(() => {
    if (!isOpen) {
      setHistory([]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return 'Unknown Date';
    return new Date(dateStr).toLocaleString();
  };

  return (
    <div className="notes-modal-overlay" onClick={onClose}>
      <div className={`notes-modal ${isHistoryView ? 'wide' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="notes-modal-header">
          <h3>{isHistoryView ? 'Call History' : title}</h3>
          <div className="notes-header-actions">
            <button 
              className="notes-modal-close" 
              onClick={onClose}
              title="Close"
              aria-label="Close modal"
            >
              <X />
            </button>
          </div>
        </div>
        
        <div className="notes-modal-content-wrapper">
          {!isHistoryView ? (
            <div className="notes-modal-body">
              {phone && <p className="notes-phone"><strong>Phone:</strong> {phone}</p>}
              {leadStatus && <p className="notes-status"><strong>Latest Status:</strong> <span style={{ color: '#06b6d4', textTransform: 'capitalize' }}>{leadStatus}</span></p>}
              <textarea 
                readOnly 
                value={notes || 'No notes available'} 
                className="notes-textarea-display"
                placeholder="No notes for this interaction."
              />
            </div>
          ) : (
            <div className="notes-history-sidebar">
              <h4>All Interactions</h4>
              {loadingHistory ? (
                <div className="history-loading">Loading history...</div>
              ) : history.length === 0 ? (
                <div className="history-empty">No previous history found.</div>
              ) : (
                <div className="history-list">
                  {history.map((record, idx) => (
                    <div key={idx} className="history-item">
                      <div className="history-meta">
                        <span className="history-date">
                          <Clock size={12} />
                          {formatDate(record.lastUpdatedAt)}
                        </span>
                        <span className={`history-status status-${record.leadStatus}`}>
                          {record.leadStatus || 'No Status'}
                        </span>
                      </div>
                      <div className="history-note">
                        {record.notes || 'No notes recorded.'}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="notes-modal-footer">
          <button 
            className="notes-modal-btn"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotesModal;
